import { APP_MODE } from '@shared/config/appMode/appMode'
import { useAppModeStore } from '@shared/config/appMode.store'
import { resolveOriginRegion } from '@shared/lib/origin/resolveOriginRegion'

import useOriginDomain from './useOriginDomain'

// UK content is shown for users from GB and for every origin except banxe.com
// (login_origin_domain / signup_origin_domain query params). An unknown origin
// falls back to UK content so crypto content is never shown by default.
const useIsUk = () => {
    const appMode = useAppModeStore((s) => s.mode)
    const isWithoutCrypto = useAppModeStore((s) => s.isWithoutCrypto)
    const isUkOrigin = resolveOriginRegion(useOriginDomain()) !== 'com'

    return appMode === APP_MODE.DEFAULT && (isWithoutCrypto || isUkOrigin)
}

export default useIsUk
